import api from "./api";

export const AuthAPI = {
  login: ({ email, password }) =>
    api("/auth/login", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    }),

  me: () => api("/auth/me"),
};